<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center m-md-5 m-3 p-xs-2">
        <b-col xs="10" sm="9" md="8">
          <b-card class="p-2 p-md-5">
            <h2>Preservetime</h2>
            <p>Sign In to your account</p>
            <b-card-group class="mt-3">
              <b-button
                variant="primary"
                class="px-4"
                v-on:click="logInAzureAd()"
                :disabled="loading"
                >Login with Azure Ad</b-button
              >
            </b-card-group>
            <hr class="mt-4 mb-4" />
            <b-card-group>
              <b-alert show variant="danger" v-if="invalidAuthorization"
                >Invalid username or password</b-alert
              >
              <b-form style="width: 100%;">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Username/Email"
                    v-model="username"
                    autocomplete="username email"
                    v-on:keyup.enter="logIn()"
                  />
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    autocomplete="current-password"
                    v-model="password"
                    v-on:keyup.enter="logIn()"
                  />
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button
                      variant="primary"
                      class="px-4"
                      v-on:click="logIn()"
                      :disabled="loading"
                    >
                      <b-spinner
                        v-if="loading"
                        class="mr-1"
                        type="border"
                        small
                      />Login
                    </b-button>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-button variant="link" class="px-0"
                      >Forgot password?</b-button
                    >
                  </b-col>
                </b-row>
              </b-form>
            </b-card-group>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { globalStore } from "../../shared/helpers";
import { userService } from "../../shared/services";
import router from "../../router";

export default {
  name: "Login",

  components: {
    computed: {
      loginState: function () {
        return globalStore.loginState;
      },
    },
  },

  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      loading: false,
      invalidAuthorization: false,
    };
  },

  methods: {
    logIn: function () {
      if (!this.username) return;

      this.loading = true;
      userService
        .login(this.username, this.password)
        .then(() => {
          this.invalidAuthorization = false;
          this.loading = false;
          router.push("/");
        })
        .catch(() => {
          this.loading = false;
          this.invalidAuthorization = true;
        });
    },
    logInAzureAd: function () {
      var redirectUri = encodeURIComponent(`${window.location.origin}/auth_callback/`);
      var url = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${process.env.VUE_APP_ID}&response_type=token&redirect_uri=${redirectUri}&scope=https://graph.microsoft.com/user.read&response_mode=fragment&state=12345&nonce=678910`;
      window.location.href = url;
    },
  },
};
</script>
